module.exports = __webpack_public_path__ + "media/src/images/partners/osnabrueck-e0aa14332849b048a43c56f951c6c097.jpg";